import { render, staticRenderFns } from "./report-xinzang.vue?vue&type=template&id=554bb568&scoped=true&"
import script from "./report-xinzang.vue?vue&type=script&lang=ts&"
export * from "./report-xinzang.vue?vue&type=script&lang=ts&"
import style0 from "./report-xinzang.vue?vue&type=style&index=0&id=554bb568&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554bb568",
  null
  
)

export default component.exports